const endPoints = {
  masters: {
    plant_layouts: {
      base: "plant_layouts",
      initForm: "plant_layouts/initform",
      qrData: "plant_layouts/qrdata",
    },
    plantLayoutResources: {
      base: "plant-layout-resources",
      initForm: "plant-layout-resources/initform",
    },
    plants: {
      base: "plant_layouts/plants",
      initForm: "plant_layouts/initform",
    },
    modules: {
      base: "plant_layouts/modules",
      modulesPlanner: "plant_layouts/modules_planner",
      initForm: "",
    },
    tags: {
      base: "tags",
      initForm: "tags/initform",
    },
    operations: {
      base: "operations",
      initForm: "operations/initform",
      qrData: "operations/qrdata",
    },
    subprocesses: {
      base: "subprocesses",
      initForm: "subprocesses/initform",
    },
    thirdparties: {
      base: "thirdparties",
      initForm: "thirdparties/initform",
    },
    attributes: {
      base: "attributes",
      initForm: "attributes/initform",
    },
    attributeValues: {
      base: "attribute_values",
      initForm: "attribute_values/initform",
    },
    colors: {
      base: "colors",
      initForm: "colors/initform",
    },
    sizeRanges: {
      base: "size_ranges",
      initForm: "size_ranges/initform",
    },
    sizes: {
      base: "sizes",
      initForm: "sizes/initform",
    },
    products: {
      base: "products",
      initForm: "products/initform",
      import: "products/import_csv",
      search: "products/search",
      duplicate: "products/duplicate",
    },
    productOperations: {
      base: "product_operations",
      initForm: "product_operations/initform",
      bulkCreate: "product_operations/bulk-create",
    },
    productColors: {
      base: "product_colors",
      initForm: "product_colors/initform",
    },
    productSizeRanges: {
      base: "product_size_ranges",
      initForm: "product_size_ranges/initform",
    },
    productAttributes: {
      base: "product_attributes",
      initForm: "product_attributes/initform",
    },
    productImages: {
      base: "product_images",
      initForm: "product_images/initform",
      image: "product_images/get_image",
    },
    constantes: {
      base: "general/constantes",
    },
    warningLevels: {
      base: "warning_levels",
      initForm: "warning_levels/initform",
      byCategory: "warning_levels/by-category",
    },
    productionStates: {
      base: "production_states",
      initForm: "production_states/initform",
    },
    employees: {
      base: "employees",
      initForm: "employees/initform",
      qrData: "employees/qrdata",
      search: "employees/search",
    },
    employeeSetup: {
      base: "employeesetup",
      initForm: "employeesetup/initform",
    },
    employeeContactPersons: {
      base: "employeecontactpersons",
      initForm: "employeecontactpersons/initform",
    },
    employeeContactMethods: {
      base: "employeecontactmethods",
      initForm: "employeecontactmethods/initform",
    },
    parameters: {
      base: "parameters",
      initForm: "parameters/initform",
    },
    contactMethods: {
      base: "contact_methods",
      initForm: "contact_methods/initform",
    },
    eventTypes: {
      base: "event_types",
      initForm: "event_types/initform",
    },
    teams: {
      base: "teams",
      list: "teams/list",
      initForm: "teams/initform",
    },
    shifts: {
      base: "shifts",
      list: "shifts/list",
      initForm: "shifts/initform",
    },
    shiftHours: {
      base: "shift_hours",
      initForm: "shift_hours/initform",
    },
    events: {
      base: "events",
      initForm: "events/initform",
    },
    eventHours: {
      base: "event_hours",
      initForm: "event_hours/initform",
    },
    processes: {
      base: "processes",
      initForm: "processes/initform",
    },
    processProviders: {
      base: "process-providers",
      byProcess: (processId) => `processes/${processId}/providers`,
      initForm: "process-providers/initform",
    },
    productProcesses: {
      base: "product-processes",
      byProduct: (productId) => `products/${productId}/processes`,
      reorder: "product-processes/reorder",
      initForm: "product-processes/initform",
    },
    resources: {
      base: "resources",
      initForm: "resources/initform",
    },
    baseRates: {
      base: "base_rates",
      initForm: "base_rates/initform",
    },
    operationLocations: {
      base: "operation_locations",
      initForm: "operation_locations/initform",
    },
    productCategories: {
      base: "product_categories",
      initForm: "product_categories/initform",
    },
    devices: {
      base: "devices",
      initForm: "devices/initform",
    },
    deviceParameters: {
      base: "device_parameters",
      initForm: "device_parameters/initform",
    },
    deviceLocations: {
      base: "device_locations",
      initForm: "device_locations/initform",
    },
    deviceEmployees: {
      base: "device_employees",
      initForm: "device_employees/initform",
    },
    devicePacks: {
      base: "device_packs",
      initForm: "device_packs/initform",
    },
    deviceOperations: {
      base: "device_operations",
      initForm: "device_operations/initform",
    },
    plantLayoutLocations: {
      base: "plant_layout_locations",
      initForm: "plant_layout_locations/initform",
    },
    offstandardCategories: {
      base: "offstandard_categories",
      initForm: "offstandard_categories/initform",
    },
    offstandards: {
      base: "offstandards",
      initForm: "offstandards/initform",
    },
    inspectionType: {
      base: "inspection_types",
      initForm: "inspection_types/initform",
    },
    testingMethod: {
      base: "testing_methods",
      initForm: "testing_methods/initform",
    },
    qualityDefect: {
      base: "quality_defects",
      initForm: "quality_defects/initform",
    },
    qualitySeverity: {
      base: "quality_severities",
      initForm: "quality_severities/initform",
    },
  },
  Dashboard: {
    base: "dashboard",
    plantas: "dashboard/plants",
    ubicaciones: "dashboard/ubicaciones",
    modalEfficiencyPlant: "dashboard/plants/efficiency",
    modalEmployeePlant: "dashboard/plants/employees",
    modalOffstandardPlant: "dashboard/plants/offstandards",
    modalQualityPlant: "dashboard/plants/quality",
    modalEfficiencyLocation: "dashboard/locations/efficiency",
    modalQualityLocation: "dashboard/locations/quality",
    modalOffstandardLocation: "dashboard/locations/offstandards",
    individualDashboard: "individual-dashboard",
  },
  DashboardEfficiency: {
    base: "dashboardefficiency",
    getPlants: "dashboardefficiency/plants",
    getModules: "dashboardefficiency/modules",
    getProcesses: "dashboardefficiency/processes",
    getLocations: "dashboardefficiency/locations",
  },
  NexoUsage: {
    summary: "ai-usage/summary",
    byClient: "ai-usage/by-client",
    byUser: "ai-usage/by-user",
    byConversation: "ai-usage/by-conversation",
    byRequest: "ai-usage/by-request",
    byProvider: "ai-usage/by-provider",
  },
  transactions: {
    workOrders: {
      base: "work_orders",
      initForm: "work_orders/initform",
      search: "work_orders/search",
      syncProcesses: (workOrderId) => `work_orders/${workOrderId}/sync-processes`,
    },
    workOrderDetails: {
      base: "work_order_details",
      initForm: "work_order_details/initform",
      byWorkOrder: (workOrderId) => `work_order_details?work_order_id=${workOrderId}`,
    },
    workOrderProcesses: {
      base: "work-order-processes",
      byWorkOrder: (workOrderId) => `work-orders/${workOrderId}/processes`,
      summary: (workOrderId) => `work-orders/${workOrderId}/processes/summary`,
      initForm: "work-order-processes/initform",
    },
    productionPlanning: {
      base: "production_planning",
      initForm: "production_planning/planner",
      move: "production_planning/move",
      movePackages: "production_planning/move_packages",
      changePriority: "production_planning/change_priority",
      quantityToProduce: "production_planning/quantity_to_program",
      comments: "work_orders/comments",
      attachments: "production_planning_attachment",
      qrData: "production_planning/qrdata",
    },
    productionPlanningDetail: {
      base: "production_planning_detail",
      initForm: "production_planning_detail/initform",
    },
    workOrderAttachment: {
      base: "work_order_attachment",
      initForm: "work_order_attachment/initform",
    },
    workOrderComment: {
      base: "work_order_comment",
      initForm: "work_order_comment/initform",
    },
    productionPlanningQuantity: {
      base: "production_planning_quantity",
      initForm: "production_planning_quantity/initform",
    },
    offstandardEmployees: {
      base: "offstandard_employees",
      initForm: "offstandard_employees/initform",
    },
    production: {
      base: "production",
      initForm: "production/initform",
    },
    productionEmployees: {
      base: "production_employees",
      initForm: "production_employees/initform",
    },
    qualityAudit: {
      base: "quality_audits",
      initForm: "quality_audits/initform",
      report: "quality_audits",
    },
    qualityAuditDefect: {
      base: "quality_audit_defects",
      initForm: "quality_audit_defects/initform",
    },
  },
  reports: {
    productionFilters: {
      filterData: "production_filters/filter_data",
      packagesByWorkOrders: "production_filters/packages_by_work_orders",
    },
    workOrderProduction: {
      report: "work_order_reports/report",
      export: "work_order_reports/export",
    },
    workOrderFilters: {
      filterData: "work_order_filters/filter_data",
    },
    qualityAuditReport: {
      report: "quality_audit_reports/report",
      export: "quality_audit_reports/export",
    },
    qualityFilters: {
      filterData: "quality_filters/filter_data",
    },
    qrPrint: {
      plantLayouts: "qr_print/plant_layouts",
      operations: "qr_print/operations",
      employees: "qr_print/employees",
      products: "qr_print/products",
      packages: "qr_print/packages",
    },
    qrLabel: {
      base: "qr_labels",
      initForm: "qr_labels/initform",
      byModule: "qr_labels/by-module",
    },
    reportTemplates: {
      base: "report_templates",
      load: (id) => `report_templates/${id}/load`,
    },
  },
  seguridad: {
    usuarios: {
      base: "seguridad/usuarios",
      initFormComponent: "seguridad/usuarios/initFormComponent",
      autocomplete: "seguridad/usuarios/autocomplete",
    },
    roles: {
      base: "seguridad/roles",
      permisos: "seguridad/roles/permisos",
      initFormComponent: "seguridad/roles/initFormComponent",
    },
    rolesPermission: {
      base: "seguridad/rolespermissions",
      getPermission: "seguridad/rolespermissions/getPermissions",
      permisos: "seguridad/roles/permisos",
      initFormComponent: "seguridad/roles/initFormComponent",
    },
    permisos: {
      byRole: "seguridad/permisos/byRole",
      byUser: "seguridad/permisos/byUser",
    },
  },
  auth: {
    login: "login",
    logout: "logout",
    getUser: "user",
    changePassword: "user/change-password",
  },
  admin: {
    clients: { base: "clients" },
    clientsStats: "clients-stats",
    clientDashboard: {
      base: "client-dashboard",
      export: "client-dashboard/export",
    },
    clientStatuses: { base: "client-statuses" },
    cartera: {
      receivables: { base: "receivables" },
      stats: "receivables-stats",
      import: "receivables/import",
      uploadProof: (id) => `receivables/${id}/payment-proof`,
      link: (id) => `receivables/${id}/link`,
      settings: "cartera-settings",
    },
    products: { base: "products" },
    priceLists: {
      base: "price-lists",
      duplicate: (id) => `price-lists/${id}/duplicate`,
    },
    priceListsActive: "price-lists-active-items",
    quotes: { base: "quotes" },
    quotesStats: "quotes-stats",
    quoteDeliveries: { base: "quote-deliveries" },
    quoteProposalTemplates: {
      base: "quote-proposal-templates",
      uploadImage: "quote-proposal-templates/upload-image",
    },
    quoteVariableDefinitions: { base: "quote-variable-definitions" },
    clientQuoteVariableValues: { base: "client-quote-variable-values" },
    quoteFormulaDefinitions: { base: "quote-formula-definitions" },
    quoteProposalPreview: "quotes/proposal-preview",
    quoteProposalRefresh: (quoteId) => `quotes/${quoteId}/proposal-refresh`,
    industries: { base: "industries" },
    currencies: { base: "currencies" },
    currencyRates: { base: "currency-rates" },
    exchangeRates: {
      suggest: "exchange-rates/suggest",
    },
    countries: { base: "countries" },
    states: { base: "states" },
    cities: { base: "cities" },
    workAreas: { base: "work-areas" },
    kanbanPriorities: { base: "kanban-priorities" },
    calendarCategories: { base: "calendar-categories" },
    areaEvents: { base: "area-events" },
    areaCalendarDays: { base: "area-calendar-days" },
    areaCapacityWeekdays: { base: "area-capacity-weekdays" },
    areaPostIts: { base: "area-post-its" },
    formDesignerForms: { base: "form-designer-forms" },
    processes: { base: "processes" },
    requirementTemplates: {
      base: "requirement-templates",
      byArea: (areaId) => `requirement-templates/by-area/${areaId}`,
    },
    requirements: {
      base: "requirements",
      submit: (id) => `requirements/${id}/submit`,
      decide: (id) => `requirements/${id}/decide`,
      reactivate: (id) => `requirements/${id}/reactivate`,
      processEstimates: (id) => `requirements/${id}/process-estimates`,
      comments: (id) => `requirements/${id}/comments`,
      comment: (commentId) => `requirement-comments/${commentId}`,
      attachments: (id) => `requirements/${id}/attachments`,
      attachment: (attachmentId) => `requirement-attachments/${attachmentId}`,
      supportKanbanBoards: "requirements/support/kanban-boards",
      supportKanbanPriorities: "requirements/support/kanban-priorities",
    },
    formExecutions: {
      byTarget: (module, entityType, entityId, formId) => `form-executions/${module}/${entityType}/${entityId}/${formId}`,
      byTargetLegacy: (entityType, entityId, formId) => `form-executions/${entityType}/${entityId}/${formId}`,
    },
    documentTypes: { base: "document-types" },
    clientRepresentatives: { base: "client-representatives" },
    clientDocuments: { base: "client-documents" },
    adminUsers: {
      base: "admin-users",
      helpdeskToken: (id) => `admin-users/${id}/helpdesk-token`,
      helpdeskTokenRevoke: (id) => `admin-users/${id}/helpdesk-token/revoke`,
    },
    adminRoles: { base: "admin-roles" },
    adminPermissions: { base: "admin-permissions" },
    myShortcuts: { base: "me/shortcuts" },
    contractTemplates: { base: "contract-templates" },
    contracts: { base: "contracts" },
    contractsStats: "contracts-stats",
    contractsRecent: "contracts-recent",
    contractSigners: { base: "contract-signers" },
    contractDeliveries: { base: "contract-deliveries" },
    companyProfile: { base: "company-profile" },
    companyRepresentatives: { base: "company-representatives" },
    companyDocuments: { base: "company-documents" },
    companyMailAccount: { base: "company-mail-account" },
    mailOauthRedirect: (provider, scope = "company") => `mail/oauth/${provider}/redirect?scope=${scope}`,
    userMailAccounts: {
      base: "mail/accounts/me",
      setDefault: (id) => `mail/accounts/me/${id}/set-default`,
    },
    notificationTemplates: { base: "notification-templates" },
    notificationRules: { base: "notification-rules" },
    notificationDispatches: { base: "notification-dispatches" },
    kanban: {
      boards: "kanban/boards",
      myWeek: "kanban/my-week",
      reportTimes: (boardId) => `kanban/boards/${boardId}/report-times`,
      reportTracking: (boardId) => `kanban/boards/${boardId}/report-tracking`,
      reportDashboard: (boardId) => `kanban/boards/${boardId}/report-dashboard`,
      reportEisenhower: (boardId) => `kanban/boards/${boardId}/report-eisenhower`,
      reportGantt: (boardId) => `kanban/boards/${boardId}/report-gantt`,
      columns: "kanban/columns",
      tags: "kanban/tags",
      cards: "kanban/cards",
      cardCommentsByCard: (cardId) => `kanban/cards/${cardId}/comments`,
      cardComment: (commentId) => `kanban/card-comments/${commentId}`,
      moveCard: (cardId) => `kanban/cards/${cardId}/move`,
      transferCard: (cardId) => `kanban/cards/${cardId}/transfer`,
      archiveCard: (cardId) => `kanban/cards/${cardId}/archive`,
      unarchiveCard: (cardId) => `kanban/cards/${cardId}/unarchive`,
      cardProcessTimes: (cardId) => `kanban/cards/${cardId}/process-times`,
      cardAttachmentsByCard: (cardId) => `kanban/cards/${cardId}/attachments`,
      cardAttachment: (attachmentId) => `kanban/card-attachments/${attachmentId}`,
      checklists: "kanban/checklists",
      checklistItems: "kanban/checklist-items",
      formExecution: (targetType, targetId, formId) => `kanban/form-executions/${targetType}/${targetId}/${formId}`,
    },
    kanbanCardTemplates: {
      base: "kanban-card-templates",
      resolveComment: "kanban-card-templates/resolve-comment",
    },
    chatConnections: { base: "chat/connections" },
    chatInbox: {
      conversations: "chat/conversations",
      sync: "chat/conversations/sync",
      messages: (conversationId) => `chat/conversations/${conversationId}/messages`,
      users: "chat/users",
      getOrCreate: "chat/conversations/get-or-create",
      escalate: (conversationId) => `chat/conversations/${conversationId}/escalate`,
    },
    releases: {
      systems: { base: "developer/releases/systems" },
      projects: { base: "developer/releases/projects" },
      dashboard: "developer/releases/dashboard",
      preflight: "developer/releases/preflight",
      syncRepos: "developer/releases/repos/sync",
      runs: "developer/releases/runs",
      show: (id) => `developer/releases/runs/${id}`,
      steps: (id) => `developer/releases/runs/${id}/steps`,
      execute: (id) => `developer/releases/runs/${id}/execute`,
      retry: (id) => `developer/releases/runs/${id}/retry`,
      cancel: (id) => `developer/releases/runs/${id}/cancel`,
    },
    infra: {
      servers: {
        base: "developer/infra/infrastructure-servers",
        events: (id) => `developer/infra/infrastructure-servers/${id}/events`,
        testConnection: (id) => `developer/infra/infrastructure-servers/${id}/test-connection`,
        bootstrapAgent: (id) => `developer/infra/infrastructure-servers/${id}/bootstrap-agent`,
        reconfigureAgent: (id) => `developer/infra/infrastructure-servers/${id}/reconfigure-agent`,
        rotateAgentToken: (id) => `developer/infra/infrastructure-servers/${id}/rotate-agent-token`,
        pauseMonitoring: (id) => `developer/infra/infrastructure-servers/${id}/pause-monitoring`,
        resumeMonitoring: (id) => `developer/infra/infrastructure-servers/${id}/resume-monitoring`,
      },
      deploymentPacks: { base: "developer/infra/deployment-packs" },
      deploymentPackVersions: { base: "developer/infra/deployment-pack-versions" },
      deploymentPackComponents: { base: "developer/infra/deployment-pack-components" },
      runtimeUnits: { base: "developer/infra/runtime-units" },
      clientTenantBindings: { base: "developer/infra/client-tenant-bindings" },
      clientTenantBindingsActions: {
        uninstall: (id) => `developer/infra/client-tenant-bindings/${id}/uninstall`,
        suspend: (id) => `developer/infra/client-tenant-bindings/${id}/suspend`,
        resume: (id) => `developer/infra/client-tenant-bindings/${id}/resume`,
      },
      provisionOperations: {
        base: "developer/infra/provision-operations",
        purge: "developer/infra/provision-operations/purge",
        show: (id) => `developer/infra/provision-operations/${id}`,
        logs: (id) => `developer/infra/provision-operations/${id}/logs`,
        status: (id) => `developer/infra/provision-operations/${id}/status`,
        pull: "developer/infra/provision-operations/pull",
        claim: (id) => `developer/infra/provision-operations/${id}/claim`,
        retry: (id) => `developer/infra/provision-operations/${id}/retry`,
        runStep: (id) => `developer/infra/provision-operations/${id}/run-step`,
        cancel: (id) => `developer/infra/provision-operations/${id}/cancel`,
        remove: (id) => `developer/infra/provision-operations/${id}`,
      },
      operationSchedules: {
        base: "developer/infra/operation-schedules",
        show: (id) => `developer/infra/operation-schedules/${id}`,
        targets: (id) => `developer/infra/operation-schedules/${id}/targets`,
        runs: (id) => `developer/infra/operation-schedules/${id}/runs`,
        runNow: (id) => `developer/infra/operation-schedules/${id}/run-now`,
        cancel: (id) => `developer/infra/operation-schedules/${id}/cancel`,
        refreshTargets: (id) => `developer/infra/operation-schedules/${id}/refresh-targets`,
      },
      serverActions: {
        base: "developer/infra/server-actions",
        purge: "developer/infra/server-actions/purge",
        show: (id) => `developer/infra/server-actions/${id}`,
        status: (id) => `developer/infra/server-actions/${id}/status`,
        approve: (id) => `developer/infra/server-actions/${id}/approve`,
        cancel: (id) => `developer/infra/server-actions/${id}/cancel`,
      },
      alerts: {
        base: "developer/infra/alerts",
        summary: "developer/infra/alerts/summary",
        show: (id) => `developer/infra/alerts/${id}`,
        ack: (id) => `developer/infra/alerts/${id}/ack`,
        resolve: (id) => `developer/infra/alerts/${id}/resolve`,
      },
      dashboard: {
        serverOverview: (serverId) => `developer/infra/dashboard/servers/${serverId}/overview`,
        serverMetrics: (serverId) => `developer/infra/dashboard/servers/${serverId}/metrics`,
        serverTenants: (serverId) => `developer/infra/dashboard/servers/${serverId}/tenants`,
        runtimeOverview: (runtimeId) => `developer/infra/dashboard/runtimes/${runtimeId}/overview`,
        tenantOverview: (bindingId) => `developer/infra/dashboard/tenants/${bindingId}/overview`,
        tenantMetrics: (bindingId) => `developer/infra/dashboard/tenants/${bindingId}/metrics`,
      },
      settings: {
        base: 'developer/infra/settings',
      },
    },
    enpisoApi: {
      config: 'developer/enpiso-api/config',
      tenants: {
        base:           'developer/enpiso-api/tenants',
        prefill: (clientId) => `developer/enpiso-api/tenants/prefill/${clientId}`,
        show:   (id) => `developer/enpiso-api/tenants/${id}`,
        test:   (id) => `developer/enpiso-api/tenants/${id}/test`,
        detect: (id) => `developer/enpiso-api/tenants/${id}/detect`,
        health: (id) => `developer/enpiso-api/tenants/${id}/health`,
        purge:  (id) => `developer/enpiso-api/tenants/${id}/purge`,
      },
      clients: {
        base:         'developer/enpiso-api/clients',
        show:  (id) => `developer/enpiso-api/clients/${id}`,
        rotateKey:        (id) => `developer/enpiso-api/clients/${id}/rotate-key`,
        sendCredentials:  (id) => `developer/enpiso-api/clients/${id}/send-credentials`,
        purge:            (id) => `developer/enpiso-api/clients/${id}/purge`,
      },
      monitoring: {
        health:   'developer/enpiso-api/monitoring/health',
        requests: 'developer/enpiso-api/monitoring/requests',
        errors:   'developer/enpiso-api/monitoring/errors',
        audit:    'developer/enpiso-api/monitoring/audit',
      },
      translations: {
        languages: 'developer/enpiso-api/translations/languages',
        keys:      'developer/enpiso-api/translations/keys',
        base:      'developer/enpiso-api/translations',
        bulk:      'developer/enpiso-api/translations/bulk',
      },
    },
    helpdeskClients: {
      base:   'developer/helpdesk-clients',
      issue:  (clientId) => `developer/helpdesk-clients/${clientId}/token`,
      revoke: (clientId) => `developer/helpdesk-clients/${clientId}/token/revoke`,
    },
  },
  chat: {
    conversations: {
      base: "conversations",
      initForm: "conversations/initform",
      getMyConversations: "conversations/my-conversations",
      getWithMessages: "conversations/get-with-messages",
      indexAllUsers: "conversations/index_all_users",
      create_group: "conversations/create-group",
      toggle_favorite: "conversations/favorite",
      check: "conversations/check",
      getOrCreate: "conversations/get-or-create",
      show: "conversations/show",
      showGroup: "conversations/show-group",
      getAllUsers: "conversations/get_all_users",
    },
    messages: {
      base: "messages",
      initForm: "messages/initform",
      group: "messages/group",
      unreadMessagesCount: "messages/unread-messages-count",
      downloadAttachment: (attachmentId) => `messages/attachments/${attachmentId}/download`,
      toggleStar: (messageId) => `messages/${messageId}/toggle-star`,
      getStarred: (conversationId) => `conversations/${conversationId}/starred-messages`,
      getAllStarred: "messages/all-starred",
    },
    mentions: {
      employees: "mention-chat/employees",
      products: "mention-chat/products",
      workOrders: "mention-chat/work-orders",
      users: "mention-chat/users",
    },
  },
  search: {
    combined: "search/combined",
  },
  notifications: {
    base: "notifications",
    unreadCount: "notifications/unread-count",
    markAsRead: "notifications/:id/mark-as-read",
    markAllAsRead: "notifications/mark-all-as-read",
  },
  themes: {
    base: "themes",
    active: "themes/active",
    setActive: "themes/active",
  },
  aiAssistant: {
    conversations: "ai-assistant/conversations",
    conversationMessages: (conversationId) => `ai-assistant/conversations/${conversationId}/messages`,
    updateConversation: (conversationId) => `ai-assistant/conversations/${conversationId}`,
    deleteConversation: (conversationId) => `ai-assistant/conversations/${conversationId}`,
    exportConversation: (conversationId, format) =>
      `ai-assistant/conversations/${conversationId}/export?format=${format}`,
    clients: "ai-assistant/clients",
    clientInitForm: "ai-assistant/clients/initform",
    clientUsers: (clientId) => `ai-assistant/clients/${clientId}/users`,
    clientAvailableUsers: (clientId) =>
      clientId
        ? `ai-assistant/clients/${clientId}/users/available`
        : 'ai-assistant/clients/users/available',
    wsChat: `${process.env.REACT_APP_AI_ASSISTANT_WS_URL || 'ws://localhost:8010'}/ws/chat`,
  },
  storage: {
    config:             'storage-config',
    test:               'storage-config/test',
    quota:              'storage-config/quota',
    compressionProfiles: 'storage-config/compression-profiles',
    compressionProfile:  (id) => `storage-config/compression-profiles/${id}`,
    resetProfiles:      'storage-config/compression-profiles/reset',
    fileServe:          (id) => `files/${id}/serve`,
    fileThumb:          (id) => `files/${id}/thumb`,
    fileDownload:       (id) => `files/${id}/download`,
  },
};

export default endPoints;
